import _ from 'lodash';
import React, { memo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import useKeyDownListener from 'hooks/useKeyDownListener';
import Avatar from 'layout/atoms/Avatar/Avatar';
import Button from 'layout/atoms/Button/Button';
import Label from 'layout/atoms/Label';
import Modal from 'layout/atoms/Modal/Modal';
import Grid from 'layout/molecules/Grid/Grid';
import { fetchMembers, selectChatMembers } from 'store/chatSlice';
import { addDirectConversation, selectInboxPrivateMessages } from 'store/inboxSlice';
import { closeModal } from 'store/layoutSlice';
import { selectUserProfileDataData } from 'store/userSlice';
import env from 'utils/env';
function DirectConversationCreator({ onClose }) {
    const { t } = useTranslation(['chat', 'common']);
    const dispatch = useDispatch();
    const [error] = useState('');
    const userId = useSelector(selectUserProfileDataData).id;
    const members = useSelector(selectChatMembers);
    const selectedMembers = useSelector(selectInboxPrivateMessages).map((dC) => dC.members.edges[0].node.user);
    const displayedMembers = _.differenceBy(members, selectedMembers, 'id').filter((member) => member.id !== userId);
    // const status = useSelector(selectInboxStatus);
    // const statusAdd = status.addDirectConversation;
    useEffect(() => {
        dispatch(fetchMembers());
    }, [dispatch]);
    const handleDirectConversationAdd = (title, id) => {
        dispatch(addDirectConversation({ title, id })).then(() => {
            dispatch(closeModal({ name: 'directConversationCreator' }));
        });
    };
    useKeyDownListener([{ code: 'Escape', callback: onClose }]);
    return (React.createElement(Modal, { name: "directConversationCreator", size: "s", header: React.createElement(Label, { weight: "strong" }, t('ADD_DIRECT_CONVERSATION')), footer: React.createElement(Button, { theme: "ghost", onClick: () => dispatch(closeModal({ name: 'directConversationCreator' })) }, t('common:cancel')) },
        React.createElement(Grid, { gap: 0 }, displayedMembers.map((member) => (React.createElement(Button, { key: member.id, align: "left", theme: "ghost", leftIcon: React.createElement(Avatar, { size: "s", shape: "round", src: member.avatar && `${env.static}/${member.avatar}`, userName: member.username }), onClick: () => handleDirectConversationAdd(member.username, member.id) }, member.username)))),
        error && React.createElement("h5", { className: "errorText" }, error)));
}
export default memo(DirectConversationCreator);
